import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=d6278f2c&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&id=d6278f2c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6278f2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6278f2c')) {
      api.createRecord('d6278f2c', component.options)
    } else {
      api.reload('d6278f2c', component.options)
    }
    module.hot.accept("./ForgotPassword.vue?vue&type=template&id=d6278f2c&scoped=true", function () {
      api.rerender('d6278f2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/common/pages/login/ForgotPassword.vue"
export default component.exports